module.exports = "/_next/static/images/3975b2c080ef538f1c059220d35c8462-nucommunity-lg@2x.jpg";